import * as React from 'react';
import PropTypes from 'prop-types';

import SvgIcon from '@mui/material/SvgIcon';

const CircularTickIcon = ({ width = 39, height = 41 }) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox="0 0 39 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={width} height={height} rx="19.5" fill="#1DA83B" />
    <path
      d="M17.9766 22.976C17.1955 23.7564 15.9297 23.7561 15.1489 22.9753L13.0974 20.9238C12.7076 20.5341 12.0761 20.533 11.6849 20.9213C11.2918 21.3117 11.2907 21.9471 11.6824 22.3388L15.1482 25.8046C15.9292 26.5857 17.1956 26.5857 17.9766 25.8046L27.8572 15.924C28.2467 15.5346 28.2467 14.9031 27.8572 14.5137C27.4679 14.1243 26.8368 14.1242 26.4472 14.5133L17.9766 22.976Z"
      fill="#F7F7F9"
    />
  </SvgIcon>
);

CircularTickIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

export default CircularTickIcon;
